import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { recentOrdersState } from "state";
import { getRecentOrders } from "../services/RecentOrdersService";
import { normalizeRecentOrders } from "../lib/recentOrders";
import customerAxiosInstance from "../api/customerAxiosInstance";
import { AuthApi } from "../api";

export const useFetchRecentOrders = ({ apiUrl, brand, env, customerData }) => {
	const [tickets, setTickets] = useRecoilState(recentOrdersState);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(async () => {
		if (customerData) {
			setIsLoading(true);
			const authApi = AuthApi(apiUrl, customerData.apiAccessToken);
			const axiosInstance = customerAxiosInstance({
				apiUrl: `${apiUrl}/customers/${customerData.id}/orders?limit=10&page=1&refundable=true`,
				brand,
				env,
				customerData,
				authApi
			})
			const recentOrders = await getRecentOrders(axiosInstance);
			setTickets(recentOrders);
			setIsLoading(false);
		} else {
			setTimeout(() => setIsLoading(false), 700);
		}
	}, [apiUrl, brand, env, customerData]);

	return {
		tickets: normalizeRecentOrders(tickets),
		isLoading
	};
};
